export const DETAIL_MODES = {
  DETAIL: 'detail',
  PROCESSING: 'processing',
  CONFLICT: 'conflict',
  SUBSIDY: {
    ALERT: 'subsidy.alert',
    SWAP: 'subsidy.swap',
  },
  ORDER: {
    SUMMARY: 'order.summary',
  },
  THANKYOU: 'thankyou',
};

export const TARIFF_UUIDS = {
  PRIMA_DATA: 11511879,
  PRIMA_GO: 11231947,
  PRIMA_SAVER: 10079414,
};

export const SERVICE_UUIDS = {
  EINVOICE: 10503007,
  TOGETHER_FREE: {
    HIGHER_TARIFF: 11044063, // vyssie pausaly
    LOWER_TARIFF_PAID: 11044064, // platena sluzba nizsie pausaly
    SLAVE_MEMBER: 11722127, // zakaznik je clenom slave skupiny
    GROUP_EXTEND: 10855914, // rozsirenie skupiny
    TWO_GROUP_MEMBER: 10855920, // clen v dvoch skupinach NZ
  },
  DAILY_DATA_PACK: {
    DETAIL: 11010782, // Denny datovy balik
    ACTIVATION: 11839711, // Denny datovy balik - aktivacna sluzba
  },
  WEEKLY_DATA_PACK: {
    DETAIL: 11010783, // Tyzdenny datovy balik
    ACTIVATION: 11839712, // Tyzdenny datovy balik - aktivacna sluzba
  },
  DATA_CAP: 11671991,
  DATA_SHARING_TOP_UP: 10542731,
  PRIMA_KIDS: {
    MASTER_SERVICE: 12256016,
    PROFILE_JUNIOR: 10946496,
    CREDIT_SERVICE: 10946941,
  },
  CYBERFILTER: {
    FAMILY: 12409171, // Online ochrana Deti
    SMART: 12409074, // Online ochrana Smart zariadenie
    PC: 12409075, // Online ochrana PC
  },
  PRIMA_MIGRATION_SERVICE: {
    // Tariff UUIDs double as fake migration service UUIDs
    PRIMA_DATA: TARIFF_UUIDS.PRIMA_DATA,
    PRIMA_GO: TARIFF_UUIDS.PRIMA_GO,
    PRIMA_SAVER: TARIFF_UUIDS.PRIMA_SAVER,
  },
};

export const RELATED_SERVICE_TYPE_CYCLE = 'cycle';
export const RELATED_SERVICE_TYPE_ONETIME = 'one-time';
export const RELATED_SERVICE_TYPE_ONETIME_OPTION = 'one-time-option';
export const RELATED_SERVICE_TYPE_EXTENSION = 'extension';
export const RELATED_SERVICE_TYPES = [
  RELATED_SERVICE_TYPE_CYCLE,
  RELATED_SERVICE_TYPE_ONETIME,
  RELATED_SERVICE_TYPE_ONETIME_OPTION,
  RELATED_SERVICE_TYPE_EXTENSION,
];

export const SERVICE_OPERATION_TYPE_ACTIVATION = 'activate';
export const SERVICE_OPERATION_TYPE_DEACTIVATION = 'deactivate';
export const SERVICE_OPERATION_TYPE_UPDATE = 'update';
